export const Roles = {
  ReadWrite: 'WRITE_ALL',
  ReadOnly: 'READ_ONLY_ALL',
  Reviewer: 'REVIEWER',
  AnalyticsOnly: 'ANALYTICS_ONLY'
}

export const LineItemTypes = {
  Product: 'product',
  Cost: 'cost'
}

export enum RefundActions {
  NoAction,
  ToExchange,
  ToReturn
}

export const RefundActionStrings = {
  NoAction: 'NO_ACTION',
  ToExchange: 'TO_EXCHANGE',
  ToReturn: 'TO_RETURN'
} as const

export enum WorkflowStatus {
  Running,
  Failed,
  Completed,
  OnHold
}

export enum TransactionTypes {
  Unknown,
  Refund,
  Exchange,
  Logistics,
  Return,
  Pickup,
  Commit,
  Lost
}

export const Platforms = {
  Shopify: 'SHOPIFY',
  Prestashop: 'PRESTASHOP',
  MagentoV2: 'MAGENTO_V2',
  Woocommmmerce: 'WOOCOMMERCE',
  Salesforce: 'SALESFORCE',
  Inditex: 'INDITEX'
}

export const OrderBy = {
  Asc: 'ASC',
  Desc: 'DESC'
}

export const ReturnStatus = {
  Started: 'STARTED',
  Collected: 'COLLECTED',
  ReviewRequired: 'REVIEW_REQUIRED',
  Completed: 'COMPLETED',
  AuthorizationPending: 'AUTHORIZATION_PENDING'
}

export enum RefundPaymentMethods {
  NoPaymentMethod,
  BankTransfer,
  Original,
  PromoCode,
  GiftCard
}

export const RefundPaymentMethodStrings = {
  NoPaymentMethod: 'NO_PAYMENT_METHOD',
  BankTransfer: 'BANK_TRANSFER',
  Original: 'ORIGINAL',
  PromoCode: 'PROMO_CODE',
  GiftCard: 'GIFT_CARD'
} as const

export const RefundTimingsStrings = {
  NoTiming: 'NO_TIMING',
  OnStartReturnProcess: 'ON_START_RETURN_PROCESS',
  OnItemSent: 'ON_ITEM_SENT',
  OnItemVerified: 'ON_ITEM_VERIFIED'
} as const

export enum RefundTimings {
  NoTiming,
  OnStartReturnProcess,
  OnItemSent,
  OnItemVerified
}

// Do not change values - used for copies
// {t(`return_methods.${method}`)}
export const ReturnMethodStrings = {
  NoReturnMethod: 'NO_RETURN_METHOD',
  PickUp: 'HOME_PICK_UP',
  DropOff: 'DROP_OFF_POINT',
  DeliveryPickup: 'DELIVERY_PICKUP',
  InStore: 'IN_STORE'
} as const

export enum ReturnMethods {
  NoReturnMethod,
  HomePickup,
  CollectionPoint,
  DeliveryPickup,
  InStore
}

export enum ShippingStatusesOld {
  NoShippingStatus,
  Created,
  Collected,
  InWarehouse,
  Error,
  Canceled
}

export const ShippingStatuses = {
  Error: 'ERROR',
  NoShippingStatus: 'NO_SHIPPING_STATUS',
  Created: 'CREATED',
  Collected: 'COLLECTED',
  InWarehouse: 'IN_WAREHOUSE',
  Canceled: 'CANCELED'
} as const

export interface MoneyFormat {
  amount: string
  currency: string
}

export enum ProcessStatuses {
  Unspecified,
  Started,
  Collected,
  ReviewRequired,
  Completed,
  Canceled,
  AuthorizationPending,
  DocumentUploadPending,
  NotAuthorized
}
